import SelectField from './SelectField';
import SelectMultiField from './SelectMultiField';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const CountryField = ({ input, disabled, label, labelRequired, placeholder, meta, multi, helpText, cssClass, config: { countryList } }) => {
  const FieldComponent = multi ? SelectMultiField : SelectField;

  // The list of countries comes from the odoo api.
  // It doesn't include a null/blank/empty option,
  // so we add that to the top of the country list.
  const options = [{ value: '', label: '-' }, ...(countryList || [])];

  return (
    <FieldComponent
      input={input}
      disabled={disabled}
      label={label}
      multi={multi}
      labelRequired={labelRequired}
      placeholder={placeholder}
      options={options}
      meta={meta}
      helpText={helpText}
      cssClass={cssClass}
    />
  );
};

CountryField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  multi: PropTypes.bool,
  helpText: PropTypes.string,
  cssClass: PropTypes.string,
  config: PropTypes.shape({
    countryList: PropTypes.array.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  labelRequired: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(CountryField);
